import REST from '../../configs/rest';
import BaseService from '../baseServices';

const twitterLogin = () => {
  const url = `${process.env.REACT_APP_REST_URL}${REST.OAUTH_TWITTER}`;
  return window.location.replace(url);
};

const getTwitterAdAccount = ({ body }) => {
  return BaseService.post(REST.OAUTH_TWITTER_AD_ACCOUNT, body);
};

const instagramLogin = () => {
  const url = `${process.env.REACT_APP_REST_URL}${REST.OAUTH_INSTAGRAM}`;
  return window.location.replace(url);
};

const getInstagramLogin = ({ body }) => {
  return BaseService.post(REST.OAUTH_INSTAGRAM_LOGIN, body);
};

const facebookPersonalLogin = () => {
  const url = `${process.env.REACT_APP_REST_URL}${REST.OAUTH_FACEBOOK_PERSONAL}`;
  return window.location.replace(url);
};

const facebookPagesLogin = () => {
  const url = `${process.env.REACT_APP_REST_URL}${REST.OAUTH_FACEBOOK_PAGE}`;
  return window.location.replace(url);
};

const getFacebookPagesLogin = ({ body }) => {
  return BaseService.post(REST.OAUTH_FACEBOOK_GET_PAGES, body);
};

const getFacebookLoginAdAccount = ({ body }) => {
  return BaseService.post(REST.OAUTH_FACEBOOK_PERSONAL_ADD_ACCOUNT, body);
};

export default {
  instagramLogin,
  getInstagramLogin,
  getTwitterAdAccount,
  twitterLogin,
  facebookPersonalLogin,
  facebookPagesLogin,
  getFacebookPagesLogin,
  getFacebookLoginAdAccount,
};
